import _ from 'lodash';

export const filters = state => _.get(state, 'form.remaindersReportFilters.values');
